const catalogConfig = {
    products: {
        label: "Products",
        endpoint: "/fincas/products",
        idKey: "idfinca_product",
        tableName: "finca_product",
        trashTable: "FincasProduct",
        fields: [
            { label: "Code", name: "code", type: "text", fieldToDisplay: "code" },
            { label: "Name", name: "name", type: "text", isEditable: false},
            {
                label: "Measure",
                name: "idfinca_measure",
                type: "dropdown",
                endpoint: "/fincas/measures",
                idKey: "idfinca_measure",
                nameKey: "unit",
                fieldToDisplay: "unit"
            },
            {
                label: "Application Mode",
                name: "idfinca_application_modes",
                type: "dropdown",
                multiple: true,
                endpoint: "/fincas/applicationModes",
                idKey: "idfinca_application_mode",
                nameKey: "name",
                fieldToDisplay: "name"
            },
            {
                label: "Product Type",
                name: "idfinca_product_type",
                type: "dropdown",
                endpoint: "/fincas/productTypes",
                idKey: "idfinca_product_type",
                nameKey: "name",
                fieldToDisplay: "name"
            },
            {
                label: "Ingredients",
                name: "ingredients",
                type: "text",
                fieldToDisplay: "ingredients"
            },
            {
                label: "EPA #",
                name: "EPA",
                type: "text",
                fieldToDisplay: "EPA"
            },
            {
                label: "Cost per Presentation",
                name: "cost_per_presentation",
                type: "number",
                isPriceField: true,
                rules: { min: 0, step: 0.01 },
                isCurrency: true
            },
            {
                label: "Total Presentation",
                name: "total_presentation",
                type: "number",
                rules: { min: 0, step: 0.01 }
            },
        ],
    },
    measures: {
        label: "Measures",
        endpoint: "/fincas/measures",
        idKey: "idfinca_measure",
        tableName: "finca_measure",
        trashTable: "FincasMeasure",
        fields: [
            { label: "Unit", name: "unit", type: "text", fieldToDisplay: "unit" },
        ],
    },
    productTypes: {
        label: "Product Types",
        endpoint: "/fincas/productTypes",
        idKey: "idfinca_product_type",
        tableName: "finca_product_type",
        trashTable: "FincasProductType",
        fields: [
            { label: "Name", name: "name", type: "text", fieldToDisplay: "name" },
        ],
    },
    applicationModes: {
        label: "Application Modes",
        endpoint: "/fincas/applicationModes",
        idKey: "idfinca_application_mode",
        tableName: "finca_application_mode",
        trashTable: "FincasApplicationMode",
        fields: [
            { label: "Name", name: "name", type: "text", fieldToDisplay: "name" },
        ],
    },
    cultivationTypes: {
        label: "Cultivation Types",
        endpoint: "/fincas/cultivationTypes",
        idKey: "idfinca_cultivation_type",
        tableName: "finca_cultivation_type",
        trashTable: "FincasCultivationType",
        fields: [
            { label: "Name", name: "name", type: "text", fieldToDisplay: "name" },
        ],
    },
    equipments: {
        label: "Equipments",
        endpoint: "/fincas/equipments",
        idKey: "idfinca_equipment",
        tableName: "finca_equipment",
        trashTable: "FincasEquipment",
        fields: [
            {
                label: "Name",
                name: "name",
                type: "text",
                fieldToDisplay: "name"
            },
        ],
    },
    farms: {
        label: "Farms",
        endpoint: "/fincas/farms",
        idKey: "idfinca_farm",
        tableName: "finca_farm",
        trashTable: "FincasFarm",
        multiDelete: true,
        fields: [
            { label: "Name", name: "name", type: "text", fieldToDisplay: "name" },
            { label: "Acres", name: "acres", type: "number", fieldToDisplay: "acres", rules: { min: 0.01, step: 0.01 } },
        ],
    },
    areas: {
        label: "Areas",
        endpoint: "/fincas/areas",
        idKey: "idfinca_area",
        multiDelete: true,
        tableName: "finca_area",
        trashTable: "FincasArea",
        fields: [
            {
                label: "Farm",
                name: "idfinca_farm",
                type: "dropdown",
                endpoint: "/fincas/farms",
                idKey: "idfinca_farm",
                nameKey: "name",
                fieldToDisplay: "name",
                showAvailableAcres: true,
            },
            { label: "Area", name: "name", type: "text", fieldToDisplay: "name" },
            { label: "Acres", name: "acres", type: "number", fieldToDisplay: "acres", rules: { min: 0.01, step: 0.01 } },
        ],
    },
    sections: {
        label: "Sections",
        endpoint: "/fincas/sections",
        idKey: "idfinca_section",
        tableName: "finca_section",
        trashTable: "FincasSection",
        multiDelete: true,
        fields: [
            {
                label: "Farm",
                name: "idfinca_farm",
                type: "dropdown",
                endpoint: "/fincas/farms",
                idKey: "idfinca_farm",
                nameKey: "name",
                fieldToDisplay: "name"
            },
            {
                label: "Area",
                name: "idfinca_area",
                type: "dropdown",
                endpoint: "/fincas/areas",
                idKey: "idfinca_area",
                nameKey: "name",
                fieldToDisplay: "name",
                showAvailableAcres: true,
                dependsOn: "idfinca_farm",
            },
            { label: "Section", name: "name", type: "text", fieldToDisplay: "name", filterRegex: /[^A-Za-z0-9]/g },
            {
                label: "Cultivation Type",
                name: "idfinca_cultivation_type",
                type: "dropdown",
                endpoint: "/fincas/cultivationTypes",
                idKey: "idfinca_cultivation_type",
                nameKey: "name",
                fieldToDisplay: "name",
            },
            { label: "Acres", name: "acres", type: "number", fieldToDisplay: "acres", rules: { min: 0.01, step: 0.01 } },
            { label: "Latitude", name: "latitude", type: "number", fieldToDisplay: "latitude", rules: { min: -90,  max: 90,  step: 0.000001 } },
            { label: "Longitude", name: "longitude", type: "number", fieldToDisplay: "longitude", rules: { min: -180, max: 180, step: 0.000001 } },
        ],
    },
};

export default catalogConfig;